var map = {
	"./4d.jpg": 82,
	"./biased.jpg": 83,
	"./cigars.jpg": 84,
	"./decisive.jpg": 85,
	"./divide.jpg": 86,
	"./fire.jpg": 87,
	"./greater_london.jpg": 88,
	"./how_to_be_well_read.jpg": 89,
	"./inside_alcatraz.jpg": 90,
	"./jeeves_wedding_bells.jpg": 91,
	"./jeeves_yule.jpg": 92,
	"./killer_wall.jpg": 93,
	"./m.jpg": 94,
	"./makers.jpg": 95,
	"./makers_hardcover.jpg": 96,
	"./marriage_game.jpg": 97,
	"./meeting_devil.jpg": 98,
	"./memory_illusion.jpg": 99,
	"./monaco.jpg": 100,
	"./originals/4d.jpg": 101,
	"./originals/biased.jpg": 102,
	"./originals/cigars.jpg": 103,
	"./originals/decisive.jpg": 104,
	"./originals/divide.jpg": 105,
	"./originals/fire.jpg": 106,
	"./originals/greater_london.jpg": 107,
	"./originals/how_to_be_well_read.jpg": 108,
	"./originals/inside_alcatraz.jpg": 109,
	"./originals/jeeves_wedding_bells.jpg": 110,
	"./originals/jeeves_yule.jpg": 111,
	"./originals/killer_wall.jpg": 112,
	"./originals/m.jpg": 113,
	"./originals/makers.jpg": 114,
	"./originals/makers_hardcover.jpg": 115,
	"./originals/marriage_game.jpg": 116,
	"./originals/meeting_devil.jpg": 117,
	"./originals/memory_illusion.jpg": 118,
	"./originals/monaco.jpg": 119,
	"./originals/rethink.jpg": 120,
	"./originals/snowdrift.jpg": 121,
	"./originals/telltale_brain.jpg": 122,
	"./originals/ten_types_human.jpg": 123,
	"./originals/the_orphans.jpg": 124,
	"./originals/wodehouse1.jpg": 125,
	"./originals/wodehouse2.jpg": 126,
	"./originals/wodehouse3.jpg": 127,
	"./rethink.jpg": 128,
	"./snowdrift.jpg": 129,
	"./telltale_brain.jpg": 130,
	"./ten_types_human.jpg": 131,
	"./the_orphans.jpg": 132,
	"./wodehouse1.jpg": 133,
	"./wodehouse2.jpg": 134,
	"./wodehouse3.jpg": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/books ^\.\/.*$
// module id = 81
// module chunks = 0